import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('unified-navigation-ui', {
  library: 'unified-navigation-ui'
});